export interface FilterFieldItem {
    value: string;
    label: string;
}

export interface FilterStatusItem {
    value: number | string;
    label: string;
}

export interface FilterPeriodItem {
    value: number;
    label: string;
}

export interface CompleteFilterValues {
    filterType: string;
    filterValue: string;
    status: number | string | null;
    startDate: string;
    endDate: string;
    period: number;
}

export const DEFAULT_PERIODS: FilterPeriodItem[] = [
    { value: 30, label: "1 Mês" },
    { value: 90, label: "3 Meses" },
    { value: 180, label: "6 Meses" },
    { value: 365, label: "1 Ano" },
    { value: 1095, label: "3 Anos" },
    { value: 1825, label: "5 Anos" },
    { value: 20000, label: "Todo o período" },
];
